"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useCase = exports.toc = exports.title = exports.slug = exports.pageId = exports.orderedTitles = exports.orderedHttpMethods = exports.name = exports.metaDescription = exports.intro = exports.defaultSelected = exports.default = void 0;
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("@mdx-js/react");
/*@jsxRuntime automatic @jsxImportSource react*/

const pageId = exports.pageId = 7;
const slug = exports.slug = 'reference/api/cms/templates/v2';
const title = exports.title = 'Templates API - V2';
const name = exports.name = 'Templates API - V2';
const metaDescription = exports.metaDescription = 'Templates API - V2';
const intro = exports.intro = 'Use the templates API to create and manage CMS templates.';
const useCase = exports.useCase = 'Retrieve version history for a website page template to understand when a certain change was made.';
const defaultSelected = exports.defaultSelected = true;
const orderedTitles = exports.orderedTitles = ['List Templates', 'Get the Template by ID', 'Gets the current contents of the auto-save buffer', 'Determine if the auto-save buffer differs from the live Template', 'List previous versions of the Template', 'Get the previous version of the Template', 'Create a new Template', 'Copy the contents of the auto-save buffer into the live Template', 'Restores a previously deleted Template', 'Restore a previous version of the Template', 'Update the Template', 'Updates the auto-save buffer', 'Delete Selected Template'];
const orderedHttpMethods = exports.orderedHttpMethods = ['GET', 'GET', 'GET', 'GET', 'GET', 'GET', 'POST', 'POST', 'POST', 'POST', 'PUT', 'PUT', 'DELETE'];
const toc = exports.toc = [];
function _createMdxContent(props) {
  const _components = Object.assign({
      p: "p",
      h3: "h3",
      table: "table",
      thead: "thead",
      tr: "tr",
      th: "th",
      tbody: "tbody",
      td: "td",
      code: "code",
      strong: "strong",
      a: "a"
    }, (0, _react.useMDXComponents)(), props.components),
    {
      EndpointCard,
      EndpointLeftColumn,
      EndpointHeader,
      Endpoint,
      EndpointRequirements,
      EndpointParameters,
      EndpointParameter,
      EndpointRightColumn,
      EndpointExample,
      EndpointJSONFields
    } = _components;
  if (!Endpoint) _missingMdxReference("Endpoint", true);
  if (!EndpointCard) _missingMdxReference("EndpointCard", true);
  if (!EndpointExample) _missingMdxReference("EndpointExample", true);
  if (!EndpointHeader) _missingMdxReference("EndpointHeader", true);
  if (!EndpointJSONFields) _missingMdxReference("EndpointJSONFields", true);
  if (!EndpointLeftColumn) _missingMdxReference("EndpointLeftColumn", true);
  if (!EndpointParameter) _missingMdxReference("EndpointParameter", true);
  if (!EndpointParameters) _missingMdxReference("EndpointParameters", true);
  if (!EndpointRequirements) _missingMdxReference("EndpointRequirements", true);
  if (!EndpointRightColumn) _missingMdxReference("EndpointRightColumn", true);
  return (0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [(0, _jsxRuntime.jsxs)(EndpointCard, {
      children: [(0, _jsxRuntime.jsxs)(EndpointLeftColumn, {
        children: [(0, _jsxRuntime.jsx)(EndpointHeader, {
          children: "List Templates"
        }), (0, _jsxRuntime.jsx)(Endpoint, {
          method: "GET",
          path: "/content/api/v2/templates"
        }), (0, _jsxRuntime.jsx)(_components.p, {
          children: "Get all templates. Supports paging and filtering."
        }), (0, _jsxRuntime.jsx)(EndpointRequirements, {
          scope: "content"
        }), (0, _jsxRuntime.jsxs)(EndpointParameters, {
          children: [(0, _jsxRuntime.jsx)(EndpointParameter, {
            name: "limit",
            schemaGroup: "Query",
            children: (0, _jsxRuntime.jsx)(_components.p, {
              children: "The number of items to return. Defaults to 20."
            })
          }), (0, _jsxRuntime.jsx)(EndpointParameter, {
            name: "offset",
            schemaGroup: "Query",
            children: (0, _jsxRuntime.jsx)(_components.p, {
              children: "The offset set to start returning rows from. Defaults to 0."
            })
          }), (0, _jsxRuntime.jsx)(EndpointParameter, {
            name: "deleted_at",
            schemaGroup: "Query",
            children: (0, _jsxRuntime.jsx)(_components.p, {
              children: "exact, gt, lt"
            })
          }), (0, _jsxRuntime.jsx)(EndpointParameter, {
            name: "id",
            schemaGroup: "Query",
            children: (0, _jsxRuntime.jsx)(_components.p, {
              children: "exact"
            })
          }), (0, _jsxRuntime.jsx)(EndpointParameter, {
            name: "is_available_for_new_content",
            schemaGroup: "Query",
            children: (0, _jsxRuntime.jsx)(_components.p, {
              children: "exact"
            })
          }), (0, _jsxRuntime.jsx)(EndpointParameter, {
            name: "label",
            schemaGroup: "Query",
            children: (0, _jsxRuntime.jsx)(_components.p, {
              children: "exact"
            })
          }), (0, _jsxRuntime.jsx)(EndpointParameter, {
            name: "path",
            schemaGroup: "Query",
            children: (0, _jsxRuntime.jsx)(_components.p, {
              children: "exact"
            })
          })]
        })]
      }), (0, _jsxRuntime.jsxs)(EndpointRightColumn, {
        children: [(0, _jsxRuntime.jsx)(EndpointExample, {
          children: (0, _jsxRuntime.jsx)(_components.p, {
            children: "CkV4YW1wbGUgR0VUIFVSTDoKaHR0cDovL2FwaS5odWJhcGkuY29tL2NvbnRlbnQvYXBpL3YyL3RlbXBsYXRlcwoKRXhhbXBsZSByZXNwb25zZToKCiAgICAKewogICAidG90YWxfY291bnQiOjEsCiAgICJvYmplY3RzIjpbCiAgICAgIHsKICAgICAgICAgImNhdGVnb3J5X2lkIjoxLAogICAgICAgICAiY2RuX21pbmlmaWVkX3VybCI6IiIsCiAgICAgICAgICJjZG5fdXJsIjoiaHR0cDovL2NkbjIuaHVic3BvdC5uZXQvaHViLzYyNTE1L2h1Yl9nZW5lcmF0ZWQvdGVtcGxhdGVfcmVzb3VyY2UvMTM4MjQ3Nzg1MTY0Ny9jdXN0b20vcGFnZS9leGFtcGxlcy9zaW1wbGUtdGVtcGxhdGUuaHRtbCIsCiAgICAgICAgICJkZWxldGVkX2F0IjowLAogICAgICAgICAiZm9sZGVyIjoiZXhhbXBsZXMiLAogICAgICAgICAiZ2VuZXJhdGVkX2Zyb21fbGF5b3V0X2lkIjpudWxsLAogICAgICAgICAiaWQiOjM1OTM5Mzk4MCwKICAgICAgICAgImlzX2F2YWlsYWJsZV9mb3JfbmV3X2NvbnRlbnQiOnRydWUsCiAgICAgICAgICJpc19mcm9tX2xheW91dCI6ZmFsc2UsCiAgICAgICAgICJpc19yZWFkX29ubHkiOmZhbHNlLAogICAgICAgICAibGFiZWwiOiJTaW1wbGUtdGVtcGxhdGUiLAogICAgICAgICAibGlua2VkX3N0eWxlX2lkIjoiIiwKICAgICAgICAgInBhdGgiOiJjdXN0b20vcGFnZS9leGFtcGxlcy9zaW1wbGUtdGVtcGxhdGUuaHRtbCIsCiAgICAgICAgICJwb3J0YWxfaWQiOjYyNTE1LAogICAgICAgICAic291cmNlIjoiVGhlIHRlbXBsYXRlIHNvdXJjZSBnb2VzIGhlcmUiLAogICAgICAgICAidGVtcGxhdGVfdHlwZSI6IjQiLAogICAgICAgICAidGh1bWJuYWlsX3dpZHRoIjoxNTQsCiAgICAgICAgICJ0eXBlIjoiIiwKICAgICAgICAgInVwZGF0ZWQiOjEzODI0Nzc4NTEwMDAsCiAgICAgICAgICJ1cGRhdGVkX2J5IjoiIgogICAgICB9CiAgIF0sCiAgICJsaW1pdCI6MjAsCiAgICJvZmZzZXQiOjAKfQoK"
          })
        }), (0, _jsxRuntime.jsxs)(EndpointJSONFields, {
          children: [(0, _jsxRuntime.jsx)(_components.h3, {
            children: "JSON Fields returned in the response"
          }), (0, _jsxRuntime.jsxs)(_components.table, {
            children: [(0, _jsxRuntime.jsx)(_components.thead, {
              children: (0, _jsxRuntime.jsxs)(_components.tr, {
                children: [(0, _jsxRuntime.jsx)(_components.th, {
                  children: "Parameter name"
                }), (0, _jsxRuntime.jsx)(_components.th, {
                  children: "Type"
                }), (0, _jsxRuntime.jsx)(_components.th, {
                  children: "Description"
                })]
              })
            }), (0, _jsxRuntime.jsxs)(_components.tbody, {
              children: [(0, _jsxRuntime.jsxs)(_components.tr, {
                children: [(0, _jsxRuntime.jsx)(_components.td, {
                  children: "archived"
                }), (0, _jsxRuntime.jsx)(_components.td, {
                  children: "bool"
                }), (0, _jsxRuntime.jsx)(_components.td, {
                  children: "If True, the template will not show up in your dashboard, although the template will still be live"
                })]
              }), (0, _jsxRuntime.jsxs)(_components.tr, {
                children: [(0, _jsxRuntime.jsx)(_components.td, {
                  children: "category_id"
                }), (0, _jsxRuntime.jsx)(_components.td, {
                  children: "string"
                }), (0, _jsxRuntime.jsx)(_components.td, {
                  children: "The category of content this template can be used for. 1 for landing page, 2 for email, 3 for site page"
                })]
              }), (0, _jsxRuntime.jsxs)(_components.tr, {
                children: [(0, _jsxRuntime.jsx)(_components.td, {
                  children: "cdn_minified_url"
                }), (0, _jsxRuntime.jsx)(_components.td, {
                  children: "string"
                }), (0, _jsxRuntime.jsx)(_components.td, {
                  children: "For JavaScript and CSS, this is the URL of the version of the content that has been rendered, minified, and uploaded to our Content Delivery Network"
                })]
              }), (0, _jsxRuntime.jsxs)(_components.tr, {
                children: [(0, _jsxRuntime.jsx)(_components.td, {
                  children: "cdn_url"
                }), (0, _jsxRuntime.jsx)(_components.td, {
                  children: "string"
                }), (0, _jsxRuntime.jsx)(_components.td, {
                  children: "For non-HTML templates, the URL to the version of the template that has been rendered and uploaded to the HubSpot CDN"
                })]
              }), (0, _jsxRuntime.jsxs)(_components.tr, {
                children: [(0, _jsxRuntime.jsx)(_components.td, {
                  children: "deleted_at"
                }), (0, _jsxRuntime.jsx)(_components.td, {
                  children: "long"
                }), (0, _jsxRuntime.jsx)(_components.td, {
                  children: "When the template was deleted, in milliseconds since the epoch. Zero if the template was never deleted. Use a DELETE request to template the page, do not set this directly."
                })]
              }), (0, _jsxRuntime.jsxs)(_components.tr, {
                children: [(0, _jsxRuntime.jsx)(_components.td, {
                  children: "folder"
                }), (0, _jsxRuntime.jsx)(_components.td, {
                  children: "string"
                }), (0, _jsxRuntime.jsx)(_components.td, {
                  children: "The folder this template lives in"
                })]
              }), (0, _jsxRuntime.jsxs)(_components.tr, {
                children: [(0, _jsxRuntime.jsx)(_components.td, {
                  children: "generated_from_layout_id"
                }), (0, _jsxRuntime.jsx)(_components.td, {
                  children: "string"
                }), (0, _jsxRuntime.jsx)(_components.td, {
                  children: "The id of the layout that generated this template"
                })]
              }), (0, _jsxRuntime.jsxs)(_components.tr, {
                children: [(0, _jsxRuntime.jsx)(_components.td, {
                  children: "id"
                }), (0, _jsxRuntime.jsx)(_components.td, {
                  children: "string"
                }), (0, _jsxRuntime.jsx)(_components.td, {
                  children: "The unique id of the template"
                })]
              }), (0, _jsxRuntime.jsxs)(_components.tr, {
                children: [(0, _jsxRuntime.jsx)(_components.td, {
                  children: "is_available_for_new_content"
                }), (0, _jsxRuntime.jsx)(_components.td, {
                  children: "string"
                }), (0, _jsxRuntime.jsx)(_components.td, {
                  children: "True if this template will show up in the content creation screen"
                })]
              }), (0, _jsxRuntime.jsxs)(_components.tr, {
                children: [(0, _jsxRuntime.jsx)(_components.td, {
                  children: "is_from_layout"
                }), (0, _jsxRuntime.jsx)(_components.td, {
                  children: "string"
                }), (0, _jsxRuntime.jsx)(_components.td, {
                  children: "True if template was generated by publishing a layout"
                })]
              }), (0, _jsxRuntime.jsxs)(_components.tr, {
                children: [(0, _jsxRuntime.jsx)(_components.td, {
                  children: "is_read_only"
                }), (0, _jsxRuntime.jsx)(_components.td, {
                  children: "string"
                }), (0, _jsxRuntime.jsx)(_components.td, {
                  children: "True if the template can only be read"
                })]
              }), (0, _jsxRuntime.jsxs)(_components.tr, {
                children: [(0, _jsxRuntime.jsx)(_components.td, {
                  children: "label"
                }), (0, _jsxRuntime.jsx)(_components.td, {
                  children: "string"
                }), (0, _jsxRuntime.jsx)(_components.td, {
                  children: "The label of the template as it shows up in the template builder"
                })]
              }), (0, _jsxRuntime.jsxs)(_components.tr, {
                children: [(0, _jsxRuntime.jsx)(_components.td, {
                  children: "path"
                }), (0, _jsxRuntime.jsx)(_components.td, {
                  children: "string"
                }), (0, _jsxRuntime.jsx)(_components.td, {
                  children: "The path of the template, as should be used for HubL include statements"
                })]
              }), (0, _jsxRuntime.jsxs)(_components.tr, {
                children: [(0, _jsxRuntime.jsx)(_components.td, {
                  children: "source"
                }), (0, _jsxRuntime.jsx)(_components.td, {
                  children: "string"
                }), (0, _jsxRuntime.jsx)(_components.td, {
                  children: "The markup of the template"
                })]
              }), (0, _jsxRuntime.jsxs)(_components.tr, {
                children: [(0, _jsxRuntime.jsx)(_components.td, {
                  children: "thumbnail_path"
                }), (0, _jsxRuntime.jsx)(_components.td, {
                  children: "string"
                }), (0, _jsxRuntime.jsx)(_components.td, {
                  children: "The thumbnail image of the template"
                })]
              }), (0, _jsxRuntime.jsxs)(_components.tr, {
                children: [(0, _jsxRuntime.jsx)(_components.td, {
                  children: "updated"
                }), (0, _jsxRuntime.jsx)(_components.td, {
                  children: "long"
                }), (0, _jsxRuntime.jsx)(_components.td, {
                  children: "When the template was last updated, in milliseconds since the epoch"
                })]
              })]
            })]
          })]
        })]
      })]
    }), "\n", (0, _jsxRuntime.jsxs)(EndpointCard, {
      children: [(0, _jsxRuntime.jsxs)(EndpointLeftColumn, {
        children: [(0, _jsxRuntime.jsx)(EndpointHeader, {
          children: "Get the Template by ID"
        }), (0, _jsxRuntime.jsx)(Endpoint, {
          method: "GET",
          path: "/content/api/v2/templates/:template_id"
        }), (0, _jsxRuntime.jsx)(_components.p, {
          children: "Get a specific template by ID."
        }), (0, _jsxRuntime.jsx)(EndpointRequirements, {
          scope: "content"
        }), (0, _jsxRuntime.jsx)(EndpointParameters, {
          children: (0, _jsxRuntime.jsx)(EndpointParameter, {
            name: "template_id",
            required: true,
            schemaGroup: "Path",
            children: (0, _jsxRuntime.jsx)(_components.p, {
              children: "The unique id of the template."
            })
          })
        })]
      }), (0, _jsxRuntime.jsxs)(EndpointRightColumn, {
        children: [(0, _jsxRuntime.jsx)(EndpointExample, {
          children: (0, _jsxRuntime.jsx)(_components.p, {
            children: "CkV4YW1wbGUgR0VUIFVSTDogCmh0dHA6Ly9hcGkuaHViYXBpLmNvbS9jb250ZW50L2FwaS92Mi90ZW1wbGF0ZXMvMzU5MzkzOTgwCgpFeGFtcGxlIHJlc3BvbnNlOiAKICB7CgkiY2F0ZWdvcnlfaWQiOjEsCgkiY2RuX21pbmlmaWVkX3VybCI6IiIsCgkiY2RuX3VybCI6Imh0dHA6Ly9jZG4yLmh1YnNwb3QubmV0L2h1Yi82MjUxNS9odWJfZ2VuZXJhdGVkL3RlbXBsYXRlX3Jlc291cmNlLzEzODI0Nzc4NTE2NDcvY3VzdG9tL3BhZ2UvZXhhbXBsZXMvc2ltcGxlLXRlbXBsYXRlLmh0bWwiLAoJImRlbGV0ZWRfYXQiOjAsCgkiZm9sZGVyIjoiZXhhbXBsZXMiLAoJImdlbmVyYXRlZF9mcm9tX2xheW91dF9pZCI6bnVsbCwKCSJpZCI6MzU5MzkzOTgwLAoJImlzX2F2YWlsYWJsZV9mb3JfbmV3X2NvbnRlbnQiOnRydWUsCgkiaXNfZnJvbV9sYXlvdXQiOmZhbHNlLAoJImlzX3JlYWRfb25seSI6ZmFsc2UsCgkibGFiZWwiOiJTaW1wbGUtdGVtcGxhdGUiLAoJImxpbmtlZF9zdHlsZV9pZCI6IiIsCgkicGF0aCI6ImN1c3RvbS9wYWdlL2V4YW1wbGVzL3NpbXBsZS10ZW1wbGF0ZS5odG1sIiwKCSJwb3J0YWxfaWQiOjYyNTE1LAoJInNvdXJjZSI6IlRoZSB0ZW1wbGF0ZSBzb3VyY2UgZ29lcyBoZXJlIiwKCSJ0ZW1wbGF0ZV90eXBlIjoiNCIsCgkidGh1bWJuYWlsX3BhdGgiOm51bGwsCgkidGh1bWJuYWlsX3dpZHRoIjoxNTQsCgkidHlwZSI6IiIsCgkidXBkYXRlZCI6MTM4MjQ3Nzg1MTAwMCwKCSJ1cGRhdGVkX2J5IjoiIgogIH0K"
          })
        }), (0, _jsxRuntime.jsxs)(EndpointJSONFields, {
          children: [(0, _jsxRuntime.jsx)(_components.h3, {
            children: "JSON Fields returned in the response"
          }), (0, _jsxRuntime.jsxs)(_components.table, {
            children: [(0, _jsxRuntime.jsx)(_components.thead, {
              children: (0, _jsxRuntime.jsxs)(_components.tr, {
                children: [(0, _jsxRuntime.jsx)(_components.th, {
                  children: "Parameter name"
                }), (0, _jsxRuntime.jsx)(_components.th, {
                  children: "Type"
                }), (0, _jsxRuntime.jsx)(_components.th, {
                  children: "Description"
                })]
              })
            }), (0, _jsxRuntime.jsxs)(_components.tbody, {
              children: [(0, _jsxRuntime.jsxs)(_components.tr, {
                children: [(0, _jsxRuntime.jsx)(_components.td, {
                  children: "archived"
                }), (0, _jsxRuntime.jsx)(_components.td, {
                  children: "bool"
                }), (0, _jsxRuntime.jsx)(_components.td, {
                  children: "If True, the template will not show up in your dashboard, although the template will still be live"
                })]
              }), (0, _jsxRuntime.jsxs)(_components.tr, {
                children: [(0, _jsxRuntime.jsx)(_components.td, {
                  children: "category_id"
                }), (0, _jsxRuntime.jsx)(_components.td, {
                  children: "string"
                }), (0, _jsxRuntime.jsx)(_components.td, {
                  children: "The category of content this template can be used for. 1 for landing page, 2 for email, 3 for site page"
                })]
              }), (0, _jsxRuntime.jsxs)(_components.tr, {
                children: [(0, _jsxRuntime.jsx)(_components.td, {
                  children: "cdn_minified_url"
                }), (0, _jsxRuntime.jsx)(_components.td, {
                  children: "string"
                }), (0, _jsxRuntime.jsx)(_components.td, {
                  children: "For javascript and css, this is the URL of the version of the content that has been rendered, minified, and uploaded to our Content Delivery Network"
                })]
              }), (0, _jsxRuntime.jsxs)(_components.tr, {
                children: [(0, _jsxRuntime.jsx)(_components.td, {
                  children: "cdn_url"
                }), (0, _jsxRuntime.jsx)(_components.td, {
                  children: "string"
                }), (0, _jsxRuntime.jsx)(_components.td, {
                  children: "For non-html templates, the URL to the version of the template that has been rendered and uploaded to the HubSpot CDN"
                })]
              }), (0, _jsxRuntime.jsxs)(_components.tr, {
                children: [(0, _jsxRuntime.jsx)(_components.td, {
                  children: "deleted_at"
                }), (0, _jsxRuntime.jsx)(_components.td, {
                  children: "long"
                }), (0, _jsxRuntime.jsx)(_components.td, {
                  children: "When the template was deleted, in milliseconds since the epoch. Zero if the template was never deleted. Use a DELETE request to template the page, do not set this directly."
                })]
              }), (0, _jsxRuntime.jsxs)(_components.tr, {
                children: [(0, _jsxRuntime.jsx)(_components.td, {
                  children: "folder"
                }), (0, _jsxRuntime.jsx)(_components.td, {
                  children: "string"
                }), (0, _jsxRuntime.jsx)(_components.td, {
                  children: "The folder this template lives in"
                })]
              }), (0, _jsxRuntime.jsxs)(_components.tr, {
                children: [(0, _jsxRuntime.jsx)(_components.td, {
                  children: "generated_from_layout_id"
                }), (0, _jsxRuntime.jsx)(_components.td, {
                  children: "string"
                }), (0, _jsxRuntime.jsx)(_components.td, {
                  children: "The id of the layout that generated this template"
                })]
              }), (0, _jsxRuntime.jsxs)(_components.tr, {
                children: [(0, _jsxRuntime.jsx)(_components.td, {
                  children: "id"
                }), (0, _jsxRuntime.jsx)(_components.td, {
                  children: "string"
                }), (0, _jsxRuntime.jsx)(_components.td, {
                  children: "The unique id of the template"
                })]
              }), (0, _jsxRuntime.jsxs)(_components.tr, {
                children: [(0, _jsxRuntime.jsx)(_components.td, {
                  children: "is_available_for_new_content"
                }), (0, _jsxRuntime.jsx)(_components.td, {
                  children: "string"
                }), (0, _jsxRuntime.jsx)(_components.td, {
                  children: "True if this template will show up in the content creation screen"
                })]
              }), (0, _jsxRuntime.jsxs)(_components.tr, {
                children: [(0, _jsxRuntime.jsx)(_components.td, {
                  children: "is_from_layout"
                }), (0, _jsxRuntime.jsx)(_components.td, {
                  children: "string"
                }), (0, _jsxRuntime.jsx)(_components.td, {
                  children: "True if template was generated by publishing a layout."
                })]
              }), (0, _jsxRuntime.jsxs)(_components.tr, {
                children: [(0, _jsxRuntime.jsx)(_components.td, {
                  children: "is_read_only"
                }), (0, _jsxRuntime.jsx)(_components.td, {
                  children: "string"
                }), (0, _jsxRuntime.jsx)(_components.td, {
                  children: "True if the template can only be read"
                })]
              }), (0, _jsxRuntime.jsxs)(_components.tr, {
                children: [(0, _jsxRuntime.jsx)(_components.td, {
                  children: "label"
                }), (0, _jsxRuntime.jsx)(_components.td, {
                  children: "string"
                }), (0, _jsxRuntime.jsx)(_components.td, {
                  children: "The label of the template as it shows up in the template builder"
                })]
              }), (0, _jsxRuntime.jsxs)(_components.tr, {
                children: [(0, _jsxRuntime.jsx)(_components.td, {
                  children: "path"
                }), (0, _jsxRuntime.jsx)(_components.td, {
                  children: "string"
                }), (0, _jsxRuntime.jsx)(_components.td, {
                  children: "The path of the template, as should be used for HubL include statements"
                })]
              }), (0, _jsxRuntime.jsxs)(_components.tr, {
                children: [(0, _jsxRuntime.jsx)(_components.td, {
                  children: "source"
                }), (0, _jsxRuntime.jsx)(_components.td, {
                  children: "string"
                }), (0, _jsxRuntime.jsx)(_components.td, {
                  children: "The markup of the template"
                })]
              }), (0, _jsxRuntime.jsxs)(_components.tr, {
                children: [(0, _jsxRuntime.jsx)(_components.td, {
                  children: "thumbnail_path"
                }), (0, _jsxRuntime.jsx)(_components.td, {
                  children: "string"
                }), (0, _jsxRuntime.jsx)(_components.td, {
                  children: "The thumbnail image of the template"
                })]
              }), (0, _jsxRuntime.jsxs)(_components.tr, {
                children: [(0, _jsxRuntime.jsx)(_components.td, {
                  children: "updated"
                }), (0, _jsxRuntime.jsx)(_components.td, {
                  children: "long"
                }), (0, _jsxRuntime.jsx)(_components.td, {
                  children: "When the template was last updated, in milliseconds since the epoch"
                })]
              })]
            })]
          })]
        })]
      })]
    }), "\n", (0, _jsxRuntime.jsxs)(EndpointCard, {
      children: [(0, _jsxRuntime.jsxs)(EndpointLeftColumn, {
        children: [(0, _jsxRuntime.jsx)(EndpointHeader, {
          children: (0, _jsxRuntime.jsx)(_components.p, {
            children: "Gets the current contents of the auto-save buffer"
          })
        }), (0, _jsxRuntime.jsx)(Endpoint, {
          method: "GET",
          path: "/content/api/v2/templates/:template_id/buffer"
        }), (0, _jsxRuntime.jsx)(_components.p, {
          children: "The auto-save buffer is updated continuously when a user is editing the content through the UI. Only when the user clicks \"Save\" or \"Publish\" does the auto-save buffer get copied to the live object."
        }), (0, _jsxRuntime.jsx)(EndpointRequirements, {}), (0, _jsxRuntime.jsx)(EndpointParameters, {
          children: (0, _jsxRuntime.jsx)(EndpointParameter, {
            name: "template_id",
            required: true,
            schemaGroup: "Path",
            children: (0, _jsxRuntime.jsx)(_components.p, {
              children: "Unique identifier for a particular blog."
            })
          })
        })]
      }), (0, _jsxRuntime.jsxs)(EndpointRightColumn, {
        children: [(0, _jsxRuntime.jsx)(EndpointExample, {
          children: (0, _jsxRuntime.jsx)(_components.p, {
            children: "CkV4YW1wbGUgVVJMOgpodHRwOi8vYXBpLmh1YmFwaS5jb20vY29udGVudC9hcGkvdjIvdGVtcGxhdGVzLzM1OTM5Mzk4MC9idWZmZXIKCkV4YW1wbGUgcmVzcG9uc2U6CnsKICAiYXR0YWNoZWRfc3R5bGVzaGVldHMiOiBbCiAgICAKICBdLAogICJjYXRlZ29yeV9pZCI6IDEsCiAgImNkbl9taW5pZmllZF91cmwiOiAiIiwKICAiY2RuX3VybCI6ICJodHRwOi8vY2RuMS5odWJzcG90LmNvbS9odWIvNjI1MTUvaHViX2dlbmVyYXRlZC90ZW1wbGF0ZV9yZXNvdXJjZS8xMzgyNDc3ODUxNjQ3L2N1c3RvbS9wYWdlL2V4YW1wbGVzL3NpbXBsZS10ZW1wbGF0ZS5odG1sIiwKICAiZGVsZXRlZF9hdCI6IDAsCiAgImVuYWJsZV9kb21haW5fc3R5bGVzaGVldHMiOiBudWxsLAogICJmb2xkZXIiOiAiZXhhbXBsZXMiLAogICJnZW5lcmF0ZWRfZnJvbV9sYXlvdXRfaWQiOiBudWxsLAogICJpZCI6IDM1OTM5Mzk4MCwKICAiaW5jbHVkZV9kZWZhdWx0X2N1c3RvbV9jc3MiOiBudWxsLAogICJpc19hdmFpbGFibGVfZm9yX25ld19jb250ZW50IjogdHJ1ZSwKICAiaXNfZGVsZXRhYmxlIjogMSwKICAiaXNfZnJvbV9sYXlvdXQiOiBmYWxzZSwKICAiaXNfcmVhZF9vbmx5IjogZmFsc2UsCiAgImlzX3JlbmFtZWFibGUiOiAxLAogICJpc190aGVtZV9sYXlvdXQiOiBmYWxzZSwKICAibGFiZWwiOiAiU2ltcGxlLXRlbXBsYXRlIiwKICAibGFzdF9lZGl0X3Nlc3Npb25faWQiOiBudWxsLAogICJsYXN0X2VkaXRfdXBkYXRlX2lkIjogbnVsbCwKICAibGlua2VkX3N0eWxlX2lkIjogIiIsCiAgIm1pZ3JhdGVkX2Zyb21fc3R5bGVfbWFuYWdlciI6IGZhbHNlLAogICJwYXRoIjogImN1c3RvbS9wYWdlL2V4YW1wbGVzL3NpbXBsZS10ZW1wbGF0ZS5odG1sIiwKICAicG9ydGFsX2lkIjogNjI1MTUsCiAgInNvdXJjZSI6IHslIHJhdyAlfSImbHQ7aHRtbCZndDtcbiAgICAmbHQ7aGVhZCZndDtcbiAgICAgICAge3sgY29udGVudC5odG1sX3RpdGxlIH19XG4gICAgICAgIHt7IHN0YW5kYXJkX2hlYWRlcl9pbmNsdWRlcyB9fVxuICAgICZsdDsvaGVhZCZndDtcbiAgICAmbHQ7Ym9keSZndDtcbiAgICAgICAgeyUgcmljaF90ZXh0IFwibWFpbl9jb250ZW50XCIgaHRtbD1cIlRoaXMgaXMgdGhlIHNpbXBsZXN0IHBvc3NpYmxlIHRlbXBsYXRlXCIgJX1cbiAgICAgICAge3sgc3RhbmRhcmRfZm9vdGVyX2luY2x1ZGVzIH19XG4gICAgJmx0Oy9ib2R5Jmd0O1xuJmx0Oy9odG1sJmd0OyIseyUgZW5kcmF3ICV9CiAgInRlbXBsYXRlX3R5cGUiOiA0LAogICJ0aHVtYm5haWxfcGF0aCI6ICJodHRwOi8vY2RuMS5odWJzcG90LmNvbS9odWJzaG90LzEzLzEwLzIzL2JkMmIxYjc2LWFlNmUtNGU0OS05NjNhLTBiY2JiMGQxMGZhNC5wbmciLAogICJ0aHVtYm5haWxfd2lkdGgiOiA0OTAsCiAgInR5cGUiOiAiIiwKICAidXBkYXRlZCI6IDEzODI0Nzc4NTEwMDAsCiAgInVwZGF0ZWRfYnkiOiAiIgp9"
          })
        }), (0, _jsxRuntime.jsxs)(EndpointJSONFields, {
          children: [(0, _jsxRuntime.jsx)(_components.h3, {
            children: "JSON Fields returned in the response"
          }), (0, _jsxRuntime.jsxs)(_components.table, {
            children: [(0, _jsxRuntime.jsx)(_components.thead, {
              children: (0, _jsxRuntime.jsxs)(_components.tr, {
                children: [(0, _jsxRuntime.jsx)(_components.th, {
                  children: "Parameter name"
                }), (0, _jsxRuntime.jsx)(_components.th, {
                  children: "Type"
                }), (0, _jsxRuntime.jsx)(_components.th, {
                  children: "Description"
                })]
              })
            }), (0, _jsxRuntime.jsxs)(_components.tbody, {
              children: [(0, _jsxRuntime.jsxs)(_components.tr, {
                children: [(0, _jsxRuntime.jsx)(_components.td, {
                  children: "category_id"
                }), (0, _jsxRuntime.jsx)(_components.td, {
                  children: "string"
                }), (0, _jsxRuntime.jsx)(_components.td, {
                  children: "The category of content this template can be used for. 1 for landing page, 2 for email, 3 for site page"
                })]
              }), (0, _jsxRuntime.jsxs)(_components.tr, {
                children: [(0, _jsxRuntime.jsx)(_components.td, {
                  children: "cdn_minified_url"
                }), (0, _jsxRuntime.jsx)(_components.td, {
                  children: "string"
                }), (0, _jsxRuntime.jsx)(_components.td, {
                  children: "For javascript and css, this is the URL of the version of the content that has been rendered, minified, and uploaded to our Content Delivery Network"
                })]
              }), (0, _jsxRuntime.jsxs)(_components.tr, {
                children: [(0, _jsxRuntime.jsx)(_components.td, {
                  children: "cdn_url"
                }), (0, _jsxRuntime.jsx)(_components.td, {
                  children: "string"
                }), (0, _jsxRuntime.jsx)(_components.td, {
                  children: "For non-html templates, the URL to the version of the template that has been rendered and uploaded to the HubSpot CDN"
                })]
              }), (0, _jsxRuntime.jsxs)(_components.tr, {
                children: [(0, _jsxRuntime.jsx)(_components.td, {
                  children: "created"
                }), (0, _jsxRuntime.jsx)(_components.td, {
                  children: "long"
                }), (0, _jsxRuntime.jsx)(_components.td, {
                  children: "When the template was first created, in milliseconds since the epoch"
                })]
              }), (0, _jsxRuntime.jsxs)(_components.tr, {
                children: [(0, _jsxRuntime.jsx)(_components.td, {
                  children: "deleted_at"
                }), (0, _jsxRuntime.jsx)(_components.td, {
                  children: "long"
                }), (0, _jsxRuntime.jsx)(_components.td, {
                  children: "When the template was deleted, in milliseconds since the epoch. Zero if the template was never deleted. Use a DELETE request to template the page, do not set this directly."
                })]
              }), (0, _jsxRuntime.jsxs)(_components.tr, {
                children: [(0, _jsxRuntime.jsx)(_components.td, {
                  children: "folder"
                }), (0, _jsxRuntime.jsx)(_components.td, {
                  children: "string"
                }), (0, _jsxRuntime.jsx)(_components.td, {
                  children: "The folder this template lives in"
                })]
              }), (0, _jsxRuntime.jsxs)(_components.tr, {
                children: [(0, _jsxRuntime.jsx)(_components.td, {
                  children: "generated_from_layout_id"
                }), (0, _jsxRuntime.jsx)(_components.td, {
                  children: "string"
                }), (0, _jsxRuntime.jsx)(_components.td, {
                  children: "The id of the layout that generated this template"
                })]
              }), (0, _jsxRuntime.jsxs)(_components.tr, {
                children: [(0, _jsxRuntime.jsx)(_components.td, {
                  children: "id"
                }), (0, _jsxRuntime.jsx)(_components.td, {
                  children: "string"
                }), (0, _jsxRuntime.jsx)(_components.td, {
                  children: "The unique id of the template"
                })]
              }), (0, _jsxRuntime.jsxs)(_components.tr, {
                children: [(0, _jsxRuntime.jsx)(_components.td, {
                  children: "is_available_for_new_content"
                }), (0, _jsxRuntime.jsx)(_components.td, {
                  children: "string"
                }), (0, _jsxRuntime.jsx)(_components.td, {
                  children: "True if this template will show up in the content creation screen"
                })]
              }), (0, _jsxRuntime.jsxs)(_components.tr, {
                children: [(0, _jsxRuntime.jsx)(_components.td, {
                  children: "is_from_layout"
                }), (0, _jsxRuntime.jsx)(_components.td, {
                  children: "string"
                }), (0, _jsxRuntime.jsx)(_components.td, {
                  children: "True if template was generated by publishing a layout."
                })]
              }), (0, _jsxRuntime.jsxs)(_components.tr, {
                children: [(0, _jsxRuntime.jsx)(_components.td, {
                  children: "is_read_only"
                }), (0, _jsxRuntime.jsx)(_components.td, {
                  children: "string"
                }), (0, _jsxRuntime.jsx)(_components.td, {
                  children: "True if the template can only be read"
                })]
              }), (0, _jsxRuntime.jsxs)(_components.tr, {
                children: [(0, _jsxRuntime.jsx)(_components.td, {
                  children: "label"
                }), (0, _jsxRuntime.jsx)(_components.td, {
                  children: "string"
                }), (0, _jsxRuntime.jsx)(_components.td, {
                  children: "The label of the template as it shows up in the template builder"
                })]
              }), (0, _jsxRuntime.jsxs)(_components.tr, {
                children: [(0, _jsxRuntime.jsx)(_components.td, {
                  children: "path"
                }), (0, _jsxRuntime.jsx)(_components.td, {
                  children: "string"
                }), (0, _jsxRuntime.jsx)(_components.td, {
                  children: "The path of the template, as should be used for HubL include statements"
                })]
              }), (0, _jsxRuntime.jsxs)(_components.tr, {
                children: [(0, _jsxRuntime.jsx)(_components.td, {
                  children: "source"
                }), (0, _jsxRuntime.jsx)(_components.td, {
                  children: "string"
                }), (0, _jsxRuntime.jsx)(_components.td, {
                  children: "The markup of the template"
                })]
              }), (0, _jsxRuntime.jsxs)(_components.tr, {
                children: [(0, _jsxRuntime.jsx)(_components.td, {
                  children: "thumbnail_path"
                }), (0, _jsxRuntime.jsx)(_components.td, {
                  children: "string"
                }), (0, _jsxRuntime.jsx)(_components.td, {
                  children: "The thumbnail image of the template"
                })]
              }), (0, _jsxRuntime.jsxs)(_components.tr, {
                children: [(0, _jsxRuntime.jsx)(_components.td, {
                  children: "updated"
                }), (0, _jsxRuntime.jsx)(_components.td, {
                  children: "long"
                }), (0, _jsxRuntime.jsx)(_components.td, {
                  children: "When the template was last updated, in milliseconds since the epoch"
                })]
              })]
            })]
          })]
        })]
      })]
    }), "\n", (0, _jsxRuntime.jsxs)(EndpointCard, {
      children: [(0, _jsxRuntime.jsxs)(EndpointLeftColumn, {
        children: [(0, _jsxRuntime.jsx)(EndpointHeader, {
          children: (0, _jsxRuntime.jsx)(_components.p, {
            children: "Determine if the auto-save buffer differs from the live Template"
          })
        }), (0, _jsxRuntime.jsx)(Endpoint, {
          method: "GET",
          path: "/content/api/v2/templates/:template_id/has-buffered-changes"
        }), (0, _jsxRuntime.jsxs)(_components.p, {
          children: ["Returns a dictionary: ", (0, _jsxRuntime.jsx)(_components.code, {
            children: "{\"has_buffered_changes\": false/true}"
          }), " depending on if the buffer is different from the live object."]
        }), (0, _jsxRuntime.jsx)(EndpointRequirements, {}), (0, _jsxRuntime.jsx)(EndpointParameters, {
          children: (0, _jsxRuntime.jsx)(EndpointParameter, {
            name: "template_id",
            required: true,
            schemaGroup: "Path",
            children: (0, _jsxRuntime.jsx)(_components.p, {
              children: "Unique identifier for a particular blog."
            })
          })
        })]
      }), (0, _jsxRuntime.jsx)(EndpointRightColumn, {
        children: (0, _jsxRuntime.jsx)(EndpointExample, {
          children: (0, _jsxRuntime.jsx)(_components.p, {
            children: "CkV4YW1wbGUgR0VUIFVSTDoKaHR0cDovL2FwaS5odWJhcGkuY29tL2NvbnRlbnQvYXBpL3YyL3RlbXBsYXRlcy8zNTkzOTM5ODAvaGFzLWJ1ZmZlcmVkLWNoYW5nZXMKCkV4YW1wbGUgcmVzcG9uc2U6CnsKICAiaGFzX2NoYW5nZXMiIDogdHJ1ZQp9"
          })
        })
      })]
    }), "\n", (0, _jsxRuntime.jsxs)(EndpointCard, {
      children: [(0, _jsxRuntime.jsxs)(EndpointLeftColumn, {
        children: [(0, _jsxRuntime.jsx)(EndpointHeader, {
          children: "List previous versions of the Template"
        }), (0, _jsxRuntime.jsx)(Endpoint, {
          method: "GET",
          path: "/content/api/v2/templates/:template_id/versions"
        }), (0, _jsxRuntime.jsx)(_components.p, {
          children: "Get all previous versions of a template."
        }), (0, _jsxRuntime.jsx)(EndpointRequirements, {}), (0, _jsxRuntime.jsx)(EndpointParameters, {
          children: (0, _jsxRuntime.jsx)(EndpointParameter, {
            name: "template_id",
            required: true,
            schemaGroup: "Path",
            children: (0, _jsxRuntime.jsx)(_components.p, {
              children: "Unique identifier for a particular blog."
            })
          })
        })]
      }), (0, _jsxRuntime.jsx)(EndpointRightColumn, {
        children: (0, _jsxRuntime.jsx)(EndpointExample, {
          children: (0, _jsxRuntime.jsx)(_components.p, {
            children: "CkV4YW1wbGUgVVJMOgpodHRwOi8vYXBpLmh1YmFwaS5jb20vY29udGVudC9hcGkvdjIvdGVtcGxhdGVzLzM1OTM5Mzk4MC92ZXJzaW9ucwoKRXhhbXBsZSByZXNwb25zZTp7JSByYXcgJX0KWwogIHsKICAgICJvYmplY3QiOiB7CiAgICAgICJhdHRhY2hlZF9zdHlsZXNoZWV0cyI6IFsKICAgICAgICAKICAgICAgXSwKICAgICAgImNhdGVnb3J5X2lkIjogMSwKICAgICAgImNkbl9taW5pZmllZF91cmwiOiAiIiwKICAgICAgImNkbl91cmwiOiAiIiwKICAgICAgImRlbGV0ZWRfYXQiOiAwLAogICAgICAiZW5hYmxlX2RvbWFpbl9zdHlsZXNoZWV0cyI6IG51bGwsCiAgICAgICJmb2xkZXIiOiAiZXhhbXBsZXMiLAogICAgICAiZ2VuZXJhdGVkX2Zyb21fbGF5b3V0X2lkIjogbnVsbCwKICAgICAgImlkIjogMzU5MzkzOTgwLAogICAgICAiaW5jbHVkZV9kZWZhdWx0X2N1c3RvbV9jc3MiOiBudWxsLAogICAgICAiaXNfYXZhaWxhYmxlX2Zvcl9uZXdfY29udGVudCI6IHRydWUsCiAgICAgICJpc19kZWxldGFibGUiOiAxLAogICAgICAiaXNfZnJvbV9sYXlvdXQiOiBmYWxzZSwKICAgICAgImlzX3JlYWRfb25seSI6IGZhbHNlLAogICAgICAiaXNfcmVuYW1lYWJsZSI6IDEsCiAgICAgICJpc190aGVtZV9sYXlvdXQiOiBmYWxzZSwKICAgICAgImxhYmVsIjogIlNpbXBsZS10ZW1wbGF0ZSIsCiAgICAgICJsYXN0X2VkaXRfc2Vzc2lvbl9pZCI6IG51bGwsCiAgICAgICJsYXN0X2VkaXRfdXBkYXRlX2lkIjogbnVsbCwKICAgICAgImxpbmtlZF9zdHlsZV9pZCI6ICIiLAogICAgICAibWlncmF0ZWRfZnJvbV9zdHlsZV9tYW5hZ2VyIjogZmFsc2UsCiAgICAgICJwYXRoIjogImN1c3RvbS9wYWdlL2V4YW1wbGVzL3NpbXBsZS10ZW1wbGF0ZS5odG1sIiwKICAgICAgInBvcnRhbF9pZCI6IDYyNTE1LAogICAgICAic291cmNlIjogIiZsdDtodG1sJmd0O1xuICAgICZsdDtoZWFkJmd0O1xuICAgICAgICB7eyBjb250ZW50Lmh0bWxfdGl0bGUgfX1cbiAgICAgICAge3sgc3RhbmRhcmRfaGVhZGVyX2luY2x1ZGVzIH19XG4gICAgJmx0Oy9oZWFkJmd0O1xuICAgICZsdDtib2R5Jmd0O1xuICAgICAgICB7JSByaWNoX3RleHQgXCJtYWluX2NvbnRlbnRcIiBodG1sPVwiVGhpcyBpcyB0aGUgc2ltcGxlc3QgcG9zc2libGUgdGVtcGxhdGVcIiAlfVxuICAgICAgICB7eyBzdGFuZGFyZF9mb290ZXJfaW5jbHVkZXMgfX1cbiAgICAmbHQ7L2JvZHkmZ3Q7XG4mbHQ7L2h0bWwmZ3Q7IiwKICAgICAgInRlbXBsYXRlX3R5cGUiOiAiNCIsCiAgICAgICJ0aHVtYm5haWxfcGF0aCI6ICJodHRwOi8vY2RuMS5odWJzcG90LmNvbS9odWJzaG90LzEzLzEwLzIzL2JkMmIxYjc2LWFlNmUtNGU0OS05NjNhLTBiY2JiMGQxMGZhNC5wbmciLAogICAgICAidGh1bWJuYWlsX3dpZHRoIjogNDkwLAogICAgICAidHlwZSI6ICIiLAogICAgICAidXBkYXRlZCI6IDE0NzkyNDUwMTUwMDAsCiAgICAgICJ1cGRhdGVkX2J5IjogIiIKICAgIH0sCiAgICAidXNlciI6IHsKICAgICAgInVzZXJuYW1lIjogImtleS1hcGktNzMuMjI3LjI0MC42OCwgMTA0Ljk2LjIxMC4yNDQsIDIwOS4xNzAuMTE4LjE3NSIsCiAgICAgICJpZCI6ICIiLAogICAgICAiZnVsbF9uYW1lIjogIiZsdDtmaXJzdE5hbWUmZ3Q7ICZsdDtsYXN0TmFtZSZndDsiLAogICAgICAiZW1haWwiOiAia2V5LWFwaS03My4yMjcuMjQwLjY4LCAxMDQuOTYuMjEwLjI0NCwgMjA5LjE3MC4xMTguMTc1IgogICAgfSwKICAgICJ2ZXJzaW9uX2lkIjogLTEsCiAgICAiYXV0aG9yZWRfYXQiOiAwCiAgfSwKICB7CiAgICAib2JqZWN0IjogewogICAgICAiaW5zdGFsbF9jb3VudCI6IDAsCiAgICAgICJsZWdhY3lfZW1haWxfbGF5b3V0X2lkIjogbnVsbCwKICAgICAgInNpdGVfaWQiOiAwLAogICAgICAidGh1bWJuYWlsX3dpZHRoIjogNDkwLAogICAgICAicGVyZm9ybWFibGVfdGVtcGxhdGVfaWQiOiBudWxsLAogICAgICAidGh1bWJuYWlsX3BhdGgiOiAiaHR0cDovL2NkbjEuaHVic3BvdC5jb20vaHVic2hvdC8xMy8xMC8yMy9iZDJiMWI3Ni1hZTZlLTRlNDktOTYzYS0wYmNiYjBkMTBmYTQucG5nIiwKICAgICAgImRlbGV0ZWRfYXQiOiAwLAogICAgICAiaWQiOiAzNTkzOTM5ODAsCiAgICAgICJoYXNfdXNlcl9jaGFuZ2VzIjogdHJ1ZSwKICAgICAgInBvcnRhbF9pZCI6IDYyNTE1LAogICAgICAiaXNfYXBwcm92ZWQiOiAwLAogICAgICAiaGFzX3N0eWxlX3RhZyI6IGZhbHNlLAogICAgICAicmVsZWFzZWRfYXQiOiAwLAogICAgICAic2NoZW1hX3ZlcnNpb24iOiAxLAogICAgICAibGFiZWwiOiAiU2ltcGxlLXRlbXBsYXRlIiwKICAgICAgInRlbXBsYXRlX3R5cGUiOiA0LAogICAgICAic291cmNlIjogIiZsdDtodG1sJmd0O1xuICAgICZsdDtoZWFkJmd0O1xuICAgICAgICB7eyBjb250ZW50Lmh0bWxfdGl0bGUgfX1cbiAgICAgICAge3sgc3RhbmRhcmRfaGVhZGVyX2luY2x1ZGVzIH19XG4gICAgJmx0Oy9oZWFkJmd0O1xuICAgICZsdDtib2R5Jmd0O1xuICAgICAgICB7JSByaWNoX3RleHQgXCJtYWluX2NvbnRlbnRcIiBodG1sPVwiVGhpcyBpcyB0aGUgc2ltcGxlc3QgcG9zc2libGUgdGVtcGxhdGVcIiAlfVxuICAgICAgICB7eyBzdGFuZGFyZF9mb290ZXJfaW5jbHVkZXMgfX1cbiAgICAmbHQ7L2JvZHkmZ3Q7XG4mbHQ7L2h0bWwmZ3Q7IiwKICAgICAgImFsd2F5c19pbl90ZW1wbGF0ZV9lZGl0b3IiOiAwLAogICAgICAidHlwZSI6ICIiLAogICAgICAiZXh0ZW5zaW9uX2lkIjogbnVsbCwKICAgICAgImJvZHkiOiB7CiAgICAgICAgImhhc191c2VyX2NoYW5nZXMiOiB0cnVlLAogICAgICAgICJjZG5fdXJsIjogImh0dHA6Ly9jZG4xLmh1YnNwb3QuY29tL2h1Yi82MjUxNS9odWJfZ2VuZXJhdGVkL3RlbXBsYXRlX3Jlc291cmNlLzEzODI0Nzc4NTE2NDcvY3VzdG9tL3BhZ2UvZXhhbXBsZXMvc2ltcGxlLXRlbXBsYXRlLmh0bWwiLAogICAgICAgICJoYXNfbWVudV90YWciOiBmYWxzZSwKICAgICAgICAiaGFzX3N0eWxlX3RhZyI6IGZhbHNlLAogICAgICAgICJ0aHVtYm5haWxfd2lkdGgiOiA0OTAKICAgICAgfSwKICAgICAgImNkbl91cmwiOiAiaHR0cDovL2NkbjEuaHVic3BvdC5jb20vaHViLzYyNTE1L2h1Yl9nZW5lcmF0ZWQvdGVtcGxhdGVfcmVzb3VyY2UvMTM4MjQ3Nzg1MTY0Ny9jdXN0b20vcGFnZS9leGFtcGxlcy9zaW1wbGUtdGVtcGxhdGUuaHRtbCIsCiAgICAgICJ1cGRhdGVkIjogMTM4MjQ3Nzg1MTAwMCwKICAgICAgInJlbGVhc2VfaWQiOiAiIiwKICAgICAgInVwZGF0ZWRfYnkiOiAiIiwKICAgICAgImZvbGRlcl9pZCI6IG51bGwsCiAgICAgICJwYXRoIjogImN1c3RvbS9wYWdlL2V4YW1wbGVzL3NpbXBsZS10ZW1wbGF0ZS5odG1sIiwKICAgICAgImhhc19tZW51X3RhZyI6IGZhbHNlLAogICAgICAiZXh0ZW5zaW9uX25hbWUiOiAiIiwKICAgICAgImlzX2F2YWlsYWJsZV9mb3JfbmV3X2NvbnRlbnQiOiAxLAogICAgICAiaXNfYmV0YSI6IDAsCiAgICAgICJjYXRlZ29yeV9pZCI6IDEsCiAgICAgICJsYXN0X2VkaXRlZF9hdCI6IDAKICAgIH0sCiAgICAidXNlciI6IHsKICAgICAgInVzZXJuYW1lIjogInBmaXR6c2ltbW9uc0BodWJzcG90LmNvbSIsCiAgICAgICJpZCI6ICIiLAogICAgICAiZnVsbF9uYW1lIjogIlBhdHJpY2sgRml0enNpbW1vbnMiLAogICAgICAiZW1haWwiOiAicGZpdHpzaW1tb25zQGh1YnNwb3QuY29tIgogICAgfSwKICAgICJ2ZXJzaW9uX2lkIjogNDU5NjQ1MzYzMywKICAgICJhdXRob3JlZF9hdCI6IDEzODI0Nzc4NTE3ODIKICB9LAogIHsKICAgICJvYmplY3QiOiB7CiAgICAgICJpbnN0YWxsX2NvdW50IjogMCwKICAgICAgImxlZ2FjeV9lbWFpbF9sYXlvdXRfaWQiOiBudWxsLAogICAgICAic2l0ZV9pZCI6IDAsCiAgICAgICJwZXJmb3JtYWJsZV90ZW1wbGF0ZV9pZCI6IG51bGwsCiAgICAgICJ0aHVtYm5haWxfcGF0aCI6IG51bGwsCiAgICAgICJkZWxldGVkX2F0IjogMCwKICAgICAgImlkIjogMzU5MzkzOTgwLAogICAgICAiaGFzX3VzZXJfY2hhbmdlcyI6IHRydWUsCiAgICAgICJwb3J0YWxfaWQiOiA2MjUxNSwKICAgICAgImlzX2FwcHJvdmVkIjogMCwKICAgICAgInJlbGVhc2VkX2F0IjogMCwKICAgICAgImxhYmVsIjogIlNpbXBsZS10ZW1wbGF0ZSIsCiAgICAgICJ0ZW1wbGF0ZV90eXBlIjogNCwKICAgICAgInNvdXJjZSI6ICIiLAogICAgICAiYWx3YXlzX2luX3RlbXBsYXRlX2VkaXRvciI6IDAsCiAgICAgICJ0eXBlIjogIiIsCiAgICAgICJleHRlbnNpb25faWQiOiBudWxsLAogICAgICAiYm9keSI6IHsKICAgICAgICAiaGFzX3VzZXJfY2hhbmdlcyI6IHRydWUKICAgICAgfSwKICAgICAgInVwZGF0ZWQiOiAxMzgyNDc3NzgxMDAwLAogICAgICAicmVsZWFzZV9pZCI6ICIiLAogICAgICAidXBkYXRlZF9ieSI6ICIiLAogICAgICAicGF0aCI6ICJjdXN0b20vcGFnZS9leGFtcGxlcy9zaW1wbGUtdGVtcGxhdGUuaHRtbCIsCiAgICAgICJleHRlbnNpb25fbmFtZSI6ICIiLAogICAgICAiaXNfYXZhaWxhYmxlX2Zvcl9uZXdfY29udGVudCI6IDAsCiAgICAgICJpc19iZXRhIjogMCwKICAgICAgImNhdGVnb3J5X2lkIjogMSwKICAgICAgImxhc3RfZWRpdGVkX2F0IjogMAogICAgfSwKICAgICJ1c2VyIjogewogICAgICAKICAgIH0sCiAgICAidmVyc2lvbl9pZCI6IDM1NTkwNTMzOCwKICAgICJhdXRob3JlZF9hdCI6IG51bGwKICB9Cl0KeyUgZW5kcmF3ICV9"
          })
        })
      })]
    }), "\n", (0, _jsxRuntime.jsxs)(EndpointCard, {
      children: [(0, _jsxRuntime.jsxs)(EndpointLeftColumn, {
        children: [(0, _jsxRuntime.jsx)(EndpointHeader, {
          children: "Get the previous version of the Template"
        }), (0, _jsxRuntime.jsx)(Endpoint, {
          method: "GET",
          path: "/content/api/v2/templates/:template_id/versions/:version_id"
        }), (0, _jsxRuntime.jsx)(_components.p, {
          children: "Get a specific revision of a template. Version id is the id of the version from the list previous versions endpoint."
        }), (0, _jsxRuntime.jsx)(EndpointRequirements, {}), (0, _jsxRuntime.jsxs)(EndpointParameters, {
          children: [(0, _jsxRuntime.jsx)(EndpointParameter, {
            name: "template_id",
            required: true,
            schemaGroup: "Path",
            children: (0, _jsxRuntime.jsx)(_components.p, {
              children: "Unique identifier for a particular blog."
            })
          }), (0, _jsxRuntime.jsx)(EndpointParameter, {
            name: "version_id",
            required: true,
            schemaGroup: "Path",
            children: (0, _jsxRuntime.jsx)(_components.p, {
              children: "Unique identifier for a specific version."
            })
          })]
        })]
      }), (0, _jsxRuntime.jsxs)(EndpointRightColumn, {
        children: [(0, _jsxRuntime.jsx)(EndpointExample, {
          children: (0, _jsxRuntime.jsx)(_components.p, {
            children: "CkV4YW1wbGUgR0VUIFVSTDoKaHR0cDovL2FwaS5odWJhcGkuY29tL2NvbnRlbnQvYXBpL3YyL3RlbXBsYXRlcy8zNTkzOTM5ODAvdmVyc2lvbnMvNDU5NjQ1MzYzMwoKRXhhbXBsZSByZXNwb25zZTp7JSByYXcgJX0KewogICJhdHRhY2hlZF9zdHlsZXNoZWV0cyI6IFsKICAgIAogIF0sCiAgImNhdGVnb3J5X2lkIjogMSwKICAiY2RuX21pbmlmaWVkX3VybCI6ICIiLAogICJjZG5fdXJsIjogImh0dHA6Ly9jZG4xLmh1YnNwb3QuY29tL2h1Yi82MjUxNS9odWJfZ2VuZXJhdGVkL3RlbXBsYXRlX3Jlc291cmNlLzEzODI0Nzc4NTE2NDcvY3VzdG9tL3BhZ2UvZXhhbXBsZXMvc2ltcGxlLXRlbXBsYXRlLmh0bWwiLAogICJkZWxldGVkX2F0IjogMCwKICAiZW5hYmxlX2RvbWFpbl9zdHlsZXNoZWV0cyI6IG51bGwsCiAgImZvbGRlciI6ICJleGFtcGxlcyIsCiAgImdlbmVyYXRlZF9mcm9tX2xheW91dF9pZCI6IG51bGwsCiAgImlkIjogMzU5MzkzOTgwLAogICJpbmNsdWRlX2RlZmF1bHRfY3VzdG9tX2NzcyI6IG51bGwsCiAgImlzX2F2YWlsYWJsZV9mb3JfbmV3X2NvbnRlbnQiOiAxLAogICJpc19kZWxldGFibGUiOiAxLAogICJpc19mcm9tX2xheW91dCI6IGZhbHNlLAogICJpc19yZWFkX29ubHkiOiBmYWxzZSwKICAiaXNfcmVuYW1lYWJsZSI6IDEsCiAgImlzX3RoZW1lX2xheW91dCI6IGZhbHNlLAogICJsYWJlbCI6ICJTaW1wbGUtdGVtcGxhdGUiLAogICJsYXN0X2VkaXRfc2Vzc2lvbl9pZCI6IG51bGwsCiAgImxhc3RfZWRpdF91cGRhdGVfaWQiOiBudWxsLAogICJsaW5rZWRfc3R5bGVfaWQiOiAiIiwKICAibWlncmF0ZWRfZnJvbV9zdHlsZV9tYW5hZ2VyIjogZmFsc2UsCiAgInBhdGgiOiAiY3VzdG9tL3BhZ2UvZXhhbXBsZXMvc2ltcGxlLXRlbXBsYXRlLmh0bWwiLAogICJwb3J0YWxfaWQiOiA2MjUxNSwKICAic291cmNlIjogIiZsdDtodG1sJmd0O1xuICAgICZsdDtoZWFkJmd0O1xuICAgICAgICB7eyBjb250ZW50Lmh0bWxfdGl0bGUgfX1cbiAgICAgICAge3sgc3RhbmRhcmRfaGVhZGVyX2luY2x1ZGVzIH19XG4gICAgJmx0Oy9oZWFkJmd0O1xuICAgICZsdDtib2R5Jmd0O1xuICAgICAgICB7JSByaWNoX3RleHQgXCJtYWluX2NvbnRlbnRcIiBodG1sPVwiVGhpcyBpcyB0aGUgc2ltcGxlc3QgcG9zc2libGUgdGVtcGxhdGVcIiAlfVxuICAgICAgICB7eyBzdGFuZGFyZF9mb290ZXJfaW5jbHVkZXMgfX1cbiAgICAmbHQ7L2JvZHkmZ3Q7XG4mbHQ7L2h0bWwmZ3Q7IiwKICAidGVtcGxhdGVfdHlwZSI6IDQsCiAgInRodW1ibmFpbF9wYXRoIjogImh0dHA6Ly9jZG4xLmh1YnNwb3QuY29tL2h1YnNob3QvMTMvMTAvMjMvYmQyYjFiNzYtYWU2ZS00ZTQ5LTk2M2EtMGJjYmIwZDEwZmE0LnBuZyIsCiAgInRodW1ibmFpbF93aWR0aCI6IDQ5MCwKICAidHlwZSI6ICIiLAogICJ1cGRhdGVkIjogMTM4MjQ3Nzg1MTAwMCwKICAidXBkYXRlZF9ieSI6ICIiCn0KeyUgZW5kcmF3ICV9"
          })
        }), (0, _jsxRuntime.jsxs)(EndpointJSONFields, {
          children: [(0, _jsxRuntime.jsx)(_components.h3, {
            children: "JSON Fields returned in the response"
          }), (0, _jsxRuntime.jsxs)(_components.table, {
            children: [(0, _jsxRuntime.jsx)(_components.thead, {
              children: (0, _jsxRuntime.jsxs)(_components.tr, {
                children: [(0, _jsxRuntime.jsx)(_components.th, {
                  children: "Parameter name"
                }), (0, _jsxRuntime.jsx)(_components.th, {
                  children: "Type"
                }), (0, _jsxRuntime.jsx)(_components.th, {
                  children: "Description"
                })]
              })
            }), (0, _jsxRuntime.jsxs)(_components.tbody, {
              children: [(0, _jsxRuntime.jsxs)(_components.tr, {
                children: [(0, _jsxRuntime.jsx)(_components.td, {
                  children: "archived"
                }), (0, _jsxRuntime.jsx)(_components.td, {
                  children: "bool"
                }), (0, _jsxRuntime.jsx)(_components.td, {
                  children: "If True, the template will not show up in your dashboard, although the template will still be live"
                })]
              }), (0, _jsxRuntime.jsxs)(_components.tr, {
                children: [(0, _jsxRuntime.jsx)(_components.td, {
                  children: "category_id"
                }), (0, _jsxRuntime.jsx)(_components.td, {
                  children: "string"
                }), (0, _jsxRuntime.jsx)(_components.td, {
                  children: "The category of content this template can be used for. 1 for landing page, 2 for email, 3 for site page"
                })]
              }), (0, _jsxRuntime.jsxs)(_components.tr, {
                children: [(0, _jsxRuntime.jsx)(_components.td, {
                  children: "cdn_minified_url"
                }), (0, _jsxRuntime.jsx)(_components.td, {
                  children: "string"
                }), (0, _jsxRuntime.jsx)(_components.td, {
                  children: "For javascript and css, this is the URL of the version of the content that has been rendered, minified, and uploaded to our Content Delivery Network"
                })]
              }), (0, _jsxRuntime.jsxs)(_components.tr, {
                children: [(0, _jsxRuntime.jsx)(_components.td, {
                  children: "cdn_url"
                }), (0, _jsxRuntime.jsx)(_components.td, {
                  children: "string"
                }), (0, _jsxRuntime.jsx)(_components.td, {
                  children: "For non-html templates, the URL to the version of the template that has been rendered and uploaded to the HubSpot CDN"
                })]
              }), (0, _jsxRuntime.jsxs)(_components.tr, {
                children: [(0, _jsxRuntime.jsx)(_components.td, {
                  children: "created"
                }), (0, _jsxRuntime.jsx)(_components.td, {
                  children: "long"
                }), (0, _jsxRuntime.jsx)(_components.td, {
                  children: "When the template was first created, in milliseconds since the epoch"
                })]
              }), (0, _jsxRuntime.jsxs)(_components.tr, {
                children: [(0, _jsxRuntime.jsx)(_components.td, {
                  children: "deleted_at"
                }), (0, _jsxRuntime.jsx)(_components.td, {
                  children: "long"
                }), (0, _jsxRuntime.jsx)(_components.td, {
                  children: "When the template was deleted, in milliseconds since the epoch. Zero if the template was never deleted. Use a DELETE request to template the page, do not set this directly."
                })]
              }), (0, _jsxRuntime.jsxs)(_components.tr, {
                children: [(0, _jsxRuntime.jsx)(_components.td, {
                  children: "folder"
                }), (0, _jsxRuntime.jsx)(_components.td, {
                  children: "string"
                }), (0, _jsxRuntime.jsx)(_components.td, {
                  children: "The folder this template lives in"
                })]
              }), (0, _jsxRuntime.jsxs)(_components.tr, {
                children: [(0, _jsxRuntime.jsx)(_components.td, {
                  children: "generated_from_layout_id"
                }), (0, _jsxRuntime.jsx)(_components.td, {
                  children: "string"
                }), (0, _jsxRuntime.jsx)(_components.td, {
                  children: "The id of the layout that generated this template"
                })]
              }), (0, _jsxRuntime.jsxs)(_components.tr, {
                children: [(0, _jsxRuntime.jsx)(_components.td, {
                  children: "id"
                }), (0, _jsxRuntime.jsx)(_components.td, {
                  children: "string"
                }), (0, _jsxRuntime.jsx)(_components.td, {
                  children: "The unique id of the template"
                })]
              }), (0, _jsxRuntime.jsxs)(_components.tr, {
                children: [(0, _jsxRuntime.jsx)(_components.td, {
                  children: "is_available_for_new_content"
                }), (0, _jsxRuntime.jsx)(_components.td, {
                  children: "string"
                }), (0, _jsxRuntime.jsx)(_components.td, {
                  children: "True if this template will show up in the content creation screen"
                })]
              }), (0, _jsxRuntime.jsxs)(_components.tr, {
                children: [(0, _jsxRuntime.jsx)(_components.td, {
                  children: "is_from_layout"
                }), (0, _jsxRuntime.jsx)(_components.td, {
                  children: "string"
                }), (0, _jsxRuntime.jsx)(_components.td, {
                  children: "True if template was generated by publishing a layout."
                })]
              }), (0, _jsxRuntime.jsxs)(_components.tr, {
                children: [(0, _jsxRuntime.jsx)(_components.td, {
                  children: "is_read_only"
                }), (0, _jsxRuntime.jsx)(_components.td, {
                  children: "string"
                }), (0, _jsxRuntime.jsx)(_components.td, {
                  children: "True if the template can only be read"
                })]
              }), (0, _jsxRuntime.jsxs)(_components.tr, {
                children: [(0, _jsxRuntime.jsx)(_components.td, {
                  children: "label"
                }), (0, _jsxRuntime.jsx)(_components.td, {
                  children: "string"
                }), (0, _jsxRuntime.jsx)(_components.td, {
                  children: "The label of the template as it shows up in the template builder"
                })]
              }), (0, _jsxRuntime.jsxs)(_components.tr, {
                children: [(0, _jsxRuntime.jsx)(_components.td, {
                  children: "path"
                }), (0, _jsxRuntime.jsx)(_components.td, {
                  children: "string"
                }), (0, _jsxRuntime.jsx)(_components.td, {
                  children: "The path of the template, as should be used for HubL include statements"
                })]
              }), (0, _jsxRuntime.jsxs)(_components.tr, {
                children: [(0, _jsxRuntime.jsx)(_components.td, {
                  children: "source"
                }), (0, _jsxRuntime.jsx)(_components.td, {
                  children: "string"
                }), (0, _jsxRuntime.jsx)(_components.td, {
                  children: "The markup of the template"
                })]
              }), (0, _jsxRuntime.jsxs)(_components.tr, {
                children: [(0, _jsxRuntime.jsx)(_components.td, {
                  children: "thumbnail_path"
                }), (0, _jsxRuntime.jsx)(_components.td, {
                  children: "string"
                }), (0, _jsxRuntime.jsx)(_components.td, {
                  children: "The thumbnail image of the template"
                })]
              }), (0, _jsxRuntime.jsxs)(_components.tr, {
                children: [(0, _jsxRuntime.jsx)(_components.td, {
                  children: "updated"
                }), (0, _jsxRuntime.jsx)(_components.td, {
                  children: "long"
                }), (0, _jsxRuntime.jsx)(_components.td, {
                  children: "When the template was last updated, in milliseconds since the epoch"
                })]
              })]
            })]
          })]
        })]
      })]
    }), "\n", (0, _jsxRuntime.jsxs)(EndpointCard, {
      children: [(0, _jsxRuntime.jsxs)(EndpointLeftColumn, {
        children: [(0, _jsxRuntime.jsx)(EndpointHeader, {
          children: "Create a new Template"
        }), (0, _jsxRuntime.jsx)(Endpoint, {
          method: "POST",
          path: "/content/api/v2/templates"
        }), (0, _jsxRuntime.jsx)(_components.p, {
          children: "Create a new coded template object in Design Manager."
        }), (0, _jsxRuntime.jsx)(EndpointRequirements, {}), (0, _jsxRuntime.jsxs)(EndpointParameters, {
          children: [(0, _jsxRuntime.jsxs)(EndpointParameter, {
            name: "category_id",
            schemaGroup: "Body",
            children: [(0, _jsxRuntime.jsx)(_components.p, {
              children: "This parameter category type:"
            }), (0, _jsxRuntime.jsxs)("ul", {
              children: [(0, _jsxRuntime.jsx)("li", {
                children: "0 - Unmapped"
              }), "\n", (0, _jsxRuntime.jsx)("li", {
                children: "1 - Landing Pages"
              }), "\n", (0, _jsxRuntime.jsx)("li", {
                children: "2 - Email"
              }), "\n", (0, _jsxRuntime.jsx)("li", {
                children: "3 - Blog Post"
              }), "\n", (0, _jsxRuntime.jsx)("li", {
                children: "4 - Site Page"
              })]
            })]
          }), (0, _jsxRuntime.jsx)(EndpointParameter, {
            name: "folder",
            schemaGroup: "Body",
            children: (0, _jsxRuntime.jsx)(_components.p, {
              children: "The name of the folder to save the template in Design Manager."
            })
          }), (0, _jsxRuntime.jsxs)(EndpointParameter, {
            name: "template_type",
            schemaGroup: "Body",
            children: [(0, _jsxRuntime.jsx)(_components.p, {
              children: "This parameter accepts a numeric value and sets the type of template that is\ncreated. The following numbers correspond to specific template types:"
            }), (0, _jsxRuntime.jsxs)("ul", {
              children: [(0, _jsxRuntime.jsx)("li", {
                children: "2 - Email template"
              }), "\n", (0, _jsxRuntime.jsx)("li", {
                children: "4 - Page template"
              }), "\n", (0, _jsxRuntime.jsx)("li", {
                children: "11 - Error template"
              }), "\n", (0, _jsxRuntime.jsx)("li", {
                children: "12 - Subscription preferences template"
              }), "\n", (0, _jsxRuntime.jsx)("li", {
                children: "13 - Backup unsubscribe page template"
              }), "\n", (0, _jsxRuntime.jsx)("li", {
                children: "14 - Subscriptions update confirmation template"
              }), "\n", (0, _jsxRuntime.jsx)("li", {
                children: "19 - Password prompt page template"
              }), "\n", (0, _jsxRuntime.jsx)("li", {
                children: "27 - Search results template"
              }), "\n", (0, _jsxRuntime.jsx)("li", {
                children: "29 - Membership login template"
              }), "\n", (0, _jsxRuntime.jsx)("li", {
                children: "30 - Membership registration template"
              }), "\n", (0, _jsxRuntime.jsx)("li", {
                children: "31 - Membership reset password confirmation template"
              }), "\n", (0, _jsxRuntime.jsx)("li", {
                children: "32 - Membership reset password request template"
              })]
            })]
          }), (0, _jsxRuntime.jsx)(EndpointParameter, {
            name: "path",
            schemaGroup: "Body",
            children: (0, _jsxRuntime.jsx)(_components.p, {
              children: "The Design Manager path to the directory that contains the file being created."
            })
          }), (0, _jsxRuntime.jsx)(EndpointParameter, {
            name: "source",
            schemaGroup: "Body",
            children: (0, _jsxRuntime.jsx)(_components.p, {
              children: "The source code of the file."
            })
          }), (0, _jsxRuntime.jsx)(EndpointParameter, {
            name: "is_available_for_new_content",
            schemaGroup: "Body",
            children: (0, _jsxRuntime.jsxs)("ul", {
              children: [(0, _jsxRuntime.jsx)("li", {
                children: (0, _jsxRuntime.jsxs)(_components.p, {
                  children: ["Used to determine if the template should be expected to pass page/content\nvalidation and be used with live content (if ", (0, _jsxRuntime.jsx)(_components.strong, {
                    children: "\"True\""
                  }), ", the template\nsource must contain ", (0, _jsxRuntime.jsx)(_components.a, {
                    href: "https://developers.hubspot.com/docs/cms/hubl/variables#required-page-variables",
                    children: "the required variables for the template\ntype"
                  }), ")."]
                })
              }), (0, _jsxRuntime.jsx)("li", {
                children: (0, _jsxRuntime.jsxs)(_components.p, {
                  children: ["This is equivalent to the \"Make Available for New Content?\" checkbox on\nPublish in the UI, and the \"Template\" vs. \"Template Partial\" radio select\non template creation in the ", (0, _jsxRuntime.jsx)(_components.a, {
                    href: "/guides/cms/tools/design-manager",
                    children: "design manager\nbeta"
                  }), "."]
                })
              }), (0, _jsxRuntime.jsxs)("li", {
                children: ["Default value is ", (0, _jsxRuntime.jsx)(_components.strong, {
                  children: "\"False\""
                }), "."]
              })]
            })
          })]
        })]
      }), (0, _jsxRuntime.jsx)(EndpointRightColumn, {
        children: (0, _jsxRuntime.jsx)(EndpointExample, {
          children: (0, _jsxRuntime.jsx)(_components.p, {
            children: "CkV4YW1wbGUgUE9TVCBVUkw6IApodHRwczovL2FwaS5odWJhcGkuY29tL2NvbnRlbnQvYXBpL3YyL3RlbXBsYXRlcwoKRXhhbXBsZSAgUE9TVCBib2R5Ogp7CiAgICAiY2F0ZWdvcnlfaWQiOiAxLAogICAgImZvbGRlciI6ICJleGFtcGxlcyIsCiAgICAiaXNfYXZhaWxhYmxlX2Zvcl9uZXdfY29udGVudCI6ICJGYWxzZSIsCiAgICAidGVtcGxhdGVfdHlwZSI6IDQsICAgICAgICAKICAgICJwYXRoIjoiY3VzdG9tL3BhZ2UvZXhhbXBsZXMvYS1uZXctdGVtcGxhdGUuaHRtbCIsCiAgICAic291cmNlIjoiVGhlIHRlbXBsYXRlIHNvdXJjZSBnb2VzIGhlcmUiCn0="
          })
        })
      })]
    }), "\n", (0, _jsxRuntime.jsxs)(EndpointCard, {
      children: [(0, _jsxRuntime.jsxs)(EndpointLeftColumn, {
        children: [(0, _jsxRuntime.jsx)(EndpointHeader, {
          children: (0, _jsxRuntime.jsx)(_components.p, {
            children: "Copy the contents of the auto-save buffer into the live Template"
          })
        }), (0, _jsxRuntime.jsx)(Endpoint, {
          method: "POST",
          path: "/content/api/v2/templates/:template_id/push-buffer-live"
        }), (0, _jsxRuntime.jsx)(_components.p, {
          children: "Copies the contents of the UI auto-save buffer into the live template."
        }), (0, _jsxRuntime.jsx)(EndpointRequirements, {}), (0, _jsxRuntime.jsx)(EndpointParameters, {
          children: (0, _jsxRuntime.jsx)(EndpointParameter, {
            name: "template_id",
            required: true,
            schemaGroup: "Path",
            children: (0, _jsxRuntime.jsx)(_components.p, {
              children: "Unique identifier for a particular blog."
            })
          })
        })]
      }), (0, _jsxRuntime.jsx)(EndpointRightColumn, {
        children: (0, _jsxRuntime.jsx)(EndpointExample, {
          children: (0, _jsxRuntime.jsx)(_components.p, {
            children: "CkV4YW1wbGUgUE9TVCBVUkw6Cmh0dHA6Ly9hcGkuaHViYXBpLmNvbS9jb250ZW50L2FwaS92Mi90ZW1wbGF0ZXMvMzU5MzkzOTgwL3B1c2gtYnVmZmVyLWxpdmUKCkRvZXMgbm90IHRha2UgYW55IGRhdGEgaW4gdGhlIHJlcXVlc3QgYm9keS4KCkV4YW1wbGUgcmVzcG9uc2U6CnsKICAiYXR0YWNoZWRfc3R5bGVzaGVldHMiOiBbCiAgICAKICBdLAogICJjYXRlZ29yeV9pZCI6IDEsCiAgImNkbl9taW5pZmllZF91cmwiOiAiIiwKICAiY2RuX3VybCI6ICIiLAogICJkZWxldGVkX2F0IjogMCwKICAiZW5hYmxlX2RvbWFpbl9zdHlsZXNoZWV0cyI6IG51bGwsCiAgImZvbGRlciI6ICJleGFtcGxlcyIsCiAgImdlbmVyYXRlZF9mcm9tX2xheW91dF9pZCI6IG51bGwsCiAgImlkIjogMzU5MzkzOTgwLAogICJpbmNsdWRlX2RlZmF1bHRfY3VzdG9tX2NzcyI6IG51bGwsCiAgImlzX2F2YWlsYWJsZV9mb3JfbmV3X2NvbnRlbnQiOiB0cnVlLAogICJpc19kZWxldGFibGUiOiAxLAogICJpc19mcm9tX2xheW91dCI6IGZhbHNlLAogICJpc19yZWFkX29ubHkiOiBmYWxzZSwKICAiaXNfcmVuYW1lYWJsZSI6IDEsCiAgImlzX3RoZW1lX2xheW91dCI6IGZhbHNlLAogICJsYWJlbCI6ICJTaW1wbGUtdGVtcGxhdGUiLAogICJsYXN0X2VkaXRfc2Vzc2lvbl9pZCI6IG51bGwsCiAgImxhc3RfZWRpdF91cGRhdGVfaWQiOiBudWxsLAogICJsaW5rZWRfc3R5bGVfaWQiOiAiIiwKICAibWlncmF0ZWRfZnJvbV9zdHlsZV9tYW5hZ2VyIjogZmFsc2UsCiAgInBhdGgiOiAiY3VzdG9tL3BhZ2UvZXhhbXBsZXMvc2ltcGxlLXRlbXBsYXRlLmh0bWwiLAogICJwb3J0YWxfaWQiOiA2MjUxNSwKICAic291cmNlIjogeyUgcmF3ICV9IiZsdDtodG1sJmd0O1xuICAgICZsdDtoZWFkJmd0O1xuICAgICAgICB7eyBjb250ZW50Lmh0bWxfdGl0bGUgfX1cbiAgICAgICAge3sgc3RhbmRhcmRfaGVhZGVyX2luY2x1ZGVzIH19XG4gICAgJmx0Oy9oZWFkJmd0O1xuICAgICZsdDtib2R5Jmd0O1xuICAgICAgICB7JSByaWNoX3RleHQgXCJtYWluX2NvbnRlbnRcIiBodG1sPVwiVGhpcyBpcyB0aGUgc2ltcGxlc3QgcG9zc2libGUgdGVtcGxhdGVcIiAlfVxuICAgICAgICB7eyBzdGFuZGFyZF9mb290ZXJfaW5jbHVkZXMgfX1cbiAgICAmbHQ7L2JvZHkmZ3Q7XG4mbHQ7L2h0bWwmZ3Q7Iix7JSBlbmRyYXcgJX0KICAidGVtcGxhdGVfdHlwZSI6IDQsCiAgInRodW1ibmFpbF9wYXRoIjogImh0dHA6Ly9jZG4xLmh1YnNwb3QuY29tL2h1YnNob3QvMTMvMTAvMjMvYmQyYjFiNzYtYWU2ZS00ZTQ5LTk2M2EtMGJjYmIwZDEwZmE0LnBuZyIsCiAgInRodW1ibmFpbF93aWR0aCI6IDQ5MCwKICAidHlwZSI6ICIiLAogICJ1cGRhdGVkIjogMTQ3OTI0NTAxNTAwMCwKICAidXBkYXRlZF9ieSI6ICIiCn0="
          })
        })
      })]
    }), "\n", (0, _jsxRuntime.jsxs)(EndpointCard, {
      children: [(0, _jsxRuntime.jsxs)(EndpointLeftColumn, {
        children: [(0, _jsxRuntime.jsx)(EndpointHeader, {
          children: "Restores a previously deleted Template"
        }), (0, _jsxRuntime.jsx)(Endpoint, {
          method: "POST",
          path: "/content/api/v2/templates/:template_id/restore-deleted"
        }), (0, _jsxRuntime.jsx)(_components.p, {
          children: "Restore a previously deleted template."
        }), (0, _jsxRuntime.jsx)(EndpointRequirements, {}), (0, _jsxRuntime.jsx)(EndpointParameters, {
          children: (0, _jsxRuntime.jsx)(EndpointParameter, {
            name: "template_id",
            required: true,
            schemaGroup: "Path",
            children: (0, _jsxRuntime.jsx)(_components.p, {
              children: "Unique identifier for a particular blog."
            })
          })
        })]
      }), (0, _jsxRuntime.jsx)(EndpointRightColumn, {
        children: (0, _jsxRuntime.jsx)(EndpointExample, {
          children: (0, _jsxRuntime.jsx)(_components.p, {
            children: "CkV4YW1wbGUgUE9TVCBVUkw6Cmh0dHA6Ly9hcGkuaHViYXBpLmNvbS9jb250ZW50L2FwaS92Mi90ZW1wbGF0ZXMvMzU5MzkzOTgwL3Jlc3RvcmUtZGVsZXRlZAoKRG9lcyBub3QgdGFrZSBhbnkgZGF0YSBpbiB0aGUgcmVxdWVzdCBib2R5LgoKRXhhbXBsZSByZXNwb25zZToKeyJzdWNjZWVkZWQiOiB0cnVlLCAibWVzc2FnZSI6ICJBY3Rpb24gc3VjY2VlZGVkIn0="
          })
        })
      })]
    }), "\n", (0, _jsxRuntime.jsxs)(EndpointCard, {
      children: [(0, _jsxRuntime.jsxs)(EndpointLeftColumn, {
        children: [(0, _jsxRuntime.jsx)(EndpointHeader, {
          children: "Restore a previous version of the Template"
        }), (0, _jsxRuntime.jsx)(Endpoint, {
          method: "POST",
          path: "/content/api/v2/templates/:template_id/versions/restore"
        }), (0, _jsxRuntime.jsx)(_components.p, {
          children: "Restore a previous version of the Template. The version_id in the request body is the ID of a specific revision of the template."
        }), (0, _jsxRuntime.jsx)(EndpointRequirements, {}), (0, _jsxRuntime.jsx)(EndpointParameters, {
          children: (0, _jsxRuntime.jsx)(EndpointParameter, {
            name: "template_id",
            required: true,
            schemaGroup: "Path",
            children: (0, _jsxRuntime.jsx)(_components.p, {
              children: "Unique identifier for a particular blog."
            })
          })
        })]
      }), (0, _jsxRuntime.jsx)(EndpointRightColumn, {
        children: (0, _jsxRuntime.jsx)(EndpointExample, {
          children: (0, _jsxRuntime.jsx)(_components.p, {
            children: "CkV4YW1wbGUgUE9TVCBVUkw6Cmh0dHA6Ly9hcGkuaHViYXBpLmNvbS9jb250ZW50L2FwaS92Mi90ZW1wbGF0ZXMvMzU5MzkzOTgwL3ZlcnNpb25zL3Jlc3RvcmUKCkV4YW1wbGUgcmVxdWVzdCBib2R5Ogp7InZlcnNpb25faWQiOiIzMjgwOTU2MjAxIn0KCkV4YW1wbGUgcmVzcG9uc2U6Cnsic3VjY2VlZGVkIjogdHJ1ZSwgIm1lc3NhZ2UiOiAiQWN0aW9uIHN1Y2NlZWRlZCJ9"
          })
        })
      })]
    }), "\n", (0, _jsxRuntime.jsxs)(EndpointCard, {
      children: [(0, _jsxRuntime.jsxs)(EndpointLeftColumn, {
        children: [(0, _jsxRuntime.jsx)(EndpointHeader, {
          children: "Update the Template"
        }), (0, _jsxRuntime.jsx)(Endpoint, {
          method: "PUT",
          path: "/content/api/v2/templates/:template_id"
        }), (0, _jsxRuntime.jsx)(_components.p, {
          children: "Updates a template. If not all the fields are included in the body, we will only update the included fields."
        }), (0, _jsxRuntime.jsx)(EndpointRequirements, {}), (0, _jsxRuntime.jsx)(EndpointParameters, {
          children: (0, _jsxRuntime.jsx)(EndpointParameter, {
            name: "template_id",
            required: true,
            schemaGroup: "Path",
            children: (0, _jsxRuntime.jsx)(_components.p, {
              children: "Unique identifier for a particular blog."
            })
          })
        })]
      }), (0, _jsxRuntime.jsx)(EndpointRightColumn, {
        children: (0, _jsxRuntime.jsx)(EndpointExample, {
          children: (0, _jsxRuntime.jsx)(_components.p, {
            children: "CkV4YW1wbGUgUFVUIFVSTDoKaHR0cHM6Ly9hcGkuaHViYXBpLmNvbS9jb250ZW50L2FwaS92Mi90ZW1wbGF0ZXMvMzU5MzkzOTgwCgpFeGFtcGxlIFBVVCBib2R5Ogp7CiAgInNvdXJjZSI6ICJ7JSByYXcgJX0mbHQ7aHRtbCZndDsmbHQ7aGVhZCZndDt7eyBjb250ZW50Lmh0bWxfdGl0bGUgfX17eyBzdGFuZGFyZF9oZWFkZXJfaW5jbHVkZXMgfX0mbHQ7L2hlYWQmZ3Q7Jmx0O2JvZHkmZ3Q7eyUgcmljaF90ZXh0IFwibWFpbl9jb250ZW50XCIgaHRtbD1cIlRoaXMgaXMgdGhlIHNpbXBsZXN0IHBvc3NpYmxlIHRlbXBsYXRlXCIgJX17eyBzdGFuZGFyZF9mb290ZXJfaW5jbHVkZXMgfX0mbHQ7L2JvZHkmZ3Q7Jmx0Oy9odG1sJmd0O3slIGVuZHJhdyAlfSIKfQoKRXhhbXBsZSByZXNwb25zZToKewogICJhdHRhY2hlZF9zdHlsZXNoZWV0cyI6IFsKICAgIAogIF0sCiAgImNhdGVnb3J5X2lkIjogMSwKICAiY2RuX21pbmlmaWVkX3VybCI6ICIiLAogICJjZG5fdXJsIjogIiIsCiAgImRlbGV0ZWRfYXQiOiAwLAogICJlbmFibGVfZG9tYWluX3N0eWxlc2hlZXRzIjogbnVsbCwKICAiZm9sZGVyIjogImV4YW1wbGVzIiwKICAiZ2VuZXJhdGVkX2Zyb21fbGF5b3V0X2lkIjogbnVsbCwKICAiaWQiOiAzNTkzOTM5ODAsCiAgImluY2x1ZGVfZGVmYXVsdF9jdXN0b21fY3NzIjogbnVsbCwKICAiaXNfYXZhaWxhYmxlX2Zvcl9uZXdfY29udGVudCI6IHRydWUsCiAgImlzX2RlbGV0YWJsZSI6IDEsCiAgImlzX2Zyb21fbGF5b3V0IjogZmFsc2UsCiAgImlzX3JlYWRfb25seSI6IGZhbHNlLAogICJpc19yZW5hbWVhYmxlIjogMSwKICAiaXNfdGhlbWVfbGF5b3V0IjogZmFsc2UsCiAgImxhYmVsIjogIlNpbXBsZS10ZW1wbGF0ZSIsCiAgImxhc3RfZWRpdF9zZXNzaW9uX2lkIjogbnVsbCwKICAibGFzdF9lZGl0X3VwZGF0ZV9pZCI6IG51bGwsCiAgImxpbmtlZF9zdHlsZV9pZCI6ICIiLAogICJtaWdyYXRlZF9mcm9tX3N0eWxlX21hbmFnZXIiOiBmYWxzZSwKICAicGF0aCI6ICJjdXN0b20vcGFnZS9leGFtcGxlcy9zaW1wbGUtdGVtcGxhdGUuaHRtbCIsCiAgInBvcnRhbF9pZCI6IDYyNTE1LAogICJzb3VyY2UiOiAieyUgcmF3ICV9Jmx0O2h0bWwmZ3Q7Jmx0O2hlYWQmZ3Q7e3sgY29udGVudC5odG1sX3RpdGxlIH19e3sgc3RhbmRhcmRfaGVhZGVyX2luY2x1ZGVzIH19Jmx0Oy9oZWFkJmd0OyZsdDtib2R5Jmd0O3slIHJpY2hfdGV4dCBcIm1haW5fY29udGVudFwiIGh0bWw9XCJUaGlzIGlzIHRoZSBzaW1wbGVzdCBwb3NzaWJsZSB0ZW1wbGF0ZVwiICV9e3sgc3RhbmRhcmRfZm9vdGVyX2luY2x1ZGVzIH19Jmx0Oy9ib2R5Jmd0OyZsdDsvaHRtbCZndDt7JSBlbmRyYXcgJX0iLAogICJ0ZW1wbGF0ZV90eXBlIjogIjQiLAogICJ0aHVtYm5haWxfcGF0aCI6ICJodHRwOi8vY2RuMS5odWJzcG90LmNvbS9odWJzaG90LzEzLzEwLzIzL2JkMmIxYjc2LWFlNmUtNGU0OS05NjNhLTBiY2JiMGQxMGZhNC5wbmciLAogICJ0aHVtYm5haWxfd2lkdGgiOiA0OTAsCiAgInR5cGUiOiAiIiwKICAidXBkYXRlZCI6IDE0ODQyNTA0ODQwMDAsCiAgInVwZGF0ZWRfYnkiOiAiIgp9"
          })
        })
      })]
    }), "\n", (0, _jsxRuntime.jsxs)(EndpointCard, {
      children: [(0, _jsxRuntime.jsxs)(EndpointLeftColumn, {
        children: [(0, _jsxRuntime.jsx)(EndpointHeader, {
          children: "Updates the auto-save buffer"
        }), (0, _jsxRuntime.jsx)(Endpoint, {
          method: "PUT",
          path: "/content/api/v2/templates/:template_id/buffer"
        }), (0, _jsxRuntime.jsx)(_components.p, {
          children: "Updates the auto-save buffer. Live objects will not be impacted."
        }), (0, _jsxRuntime.jsx)(EndpointRequirements, {
          scope: "content"
        }), (0, _jsxRuntime.jsx)(EndpointParameters, {
          children: (0, _jsxRuntime.jsx)(EndpointParameter, {
            name: "template_id",
            required: true,
            schemaGroup: "Path",
            children: (0, _jsxRuntime.jsx)(_components.p, {
              children: "Unique identifier for a particular blog."
            })
          })
        })]
      }), (0, _jsxRuntime.jsx)(EndpointRightColumn, {
        children: (0, _jsxRuntime.jsx)(EndpointExample, {
          children: (0, _jsxRuntime.jsx)(_components.p, {
            children: "CkV4YW1wbGUgUFVUIFVSTDoKYXBpLmh1YmFwaS5jb20vY29udGVudC9hcGkvdjIvdGVtcGxhdGVzLzczNTI0MjY5NjcvYnVmZmVyCgpFeGFtcGxlIFBVVCByZXNwb25zZTogCnsKICAiYW1wX3ZhbGlkYXRlZCI6IGZhbHNlLAogICJhdHRhY2hlZF9hbXBfc3R5bGVzaGVldCI6IDAsCiAgImF0dGFjaGVkX2pzIjogW10sCiAgImF0dGFjaGVkX3N0eWxlc2hlZXRzIjogW10sCiAgImJvZHkiOiB7CiAgICAiZm9sZGVyIjogInRlbXBsYXRlc19mb2xkZXIiLAogICAgImNkbl9taW5pZmllZF91cmwiOiBudWxsLAogICAgImNkbl91cmwiOiAiIiwKICAgICJoYXNfdXNlcl9jaGFuZ2VzIjogdHJ1ZSwKICAgICJoYXNfc3R5bGVfdGFnIjogZmFsc2UsCiAgICAiaGFzX21lbnVfdGFnIjogZmFsc2UKICB9LAogICJjYXRlZ29yeSI6IDEsCiAgImNhdGVnb3J5X2lkIjogMSwKICAiY2RuX21pbmlmaWVkX3VybCI6ICIiLAogICJjZG5fdXJsIjogIiIsCiAgImNvbnRlbnRfdGFncyI6IFtdLAogICJjc3Nfb3JfanNfdGVtcGxhdGUiOiBmYWxzZSwKICAiZGVmYXVsdCI6IGZhbHNlLAogICJkZWxldGVkIjogZmFsc2UsCiAgImRlbGV0ZWRfYXQiOiAwLAogICJkZXNjcmlwdGlvbl9pMThuX2tleSI6ICIiLAogICJleHRlbnNpb25fbmFtZSI6ICIiLAogICJmb2xkZXIiOiAidGVtcGxhdGVzX2ZvbGRlciIsCiAgImZvbGRlcl9pZCI6IDczNTI0MjY5NjksCiAgImhhc19zdHlsZV90YWciOiBmYWxzZSwKICAiaG9zdF90ZW1wbGF0ZV90eXBlcyI6IFsKICAgICJBTlkiCiAgXSwKICAiaWQiOiA3MzUyNDI2OTY3LAogICJpc19hdmFpbGFibGVfZm9yX25ld19jb250ZW50IjogZmFsc2UsCiAgImlzX2Zyb21fbGF5b3V0IjogZmFsc2UsCiAgImlzX21pbmlmaWFibGUiOiB0cnVlLAogICJpc19yZWFkX29ubHkiOiBmYWxzZSwKICAibGFiZWwiOiAiMTdiY2ZkYTktOGRmMi00MTgxLThiMjQtZjk0YTRlNTA0NzlkLmh0bWwiLAogICJtZXRhIjogewogICAgImhhc0J1ZmZlcmVkQ2hhbmdlcyI6IGZhbHNlCiAgfSwKICAibWlzc2luZyI6IGZhbHNlLAogICJwYXRoIjogImN1c3RvbS9wYWdlL2V4YW1wbGVzLzE3YmNmZGE5LThkZjItNDE4MS04YjI0LWY5NGE0ZTUwNDc5ZC5odG1sIiwKICAicG9ydGFsX2lkIjogNjI1MTUsCiAgInB1cmNoYXNlZCI6IGZhbHNlLAogICJyZWxlYXNlX2lkIjogIiIsCiAgInNpemUiOiAyOSwKICAic291cmNlIjogIlRoZSB0ZW1wbGF0ZSBzb3VyY2UgZ29lcyBoZXJlIiwKICAidGVtcGxhdGVfdHlwZSI6IDQsCiAgInR5cGUiOiAiIiwKICAidXBkYXRlZCI6IDE1NDg5NDI3NjAwNDUsCiAgInVwZGF0ZWRfYnkiOiAiIgp9"
          })
        })
      })]
    }), "\n", (0, _jsxRuntime.jsx)(EndpointCard, {
      children: (0, _jsxRuntime.jsxs)(EndpointLeftColumn, {
        children: [(0, _jsxRuntime.jsx)(EndpointHeader, {
          children: "Delete Selected Template"
        }), (0, _jsxRuntime.jsx)(Endpoint, {
          method: "DELETE",
          path: "/content/api/v2/templates/:template_id"
        }), (0, _jsxRuntime.jsx)(_components.p, {
          children: "Marks the selected Template as deleted. The Template can be restored later via a POST to the restore-deleted endpoint."
        }), (0, _jsxRuntime.jsx)(EndpointRequirements, {}), (0, _jsxRuntime.jsx)(EndpointParameters, {
          children: (0, _jsxRuntime.jsx)(EndpointParameter, {
            name: "template_id",
            required: true,
            schemaGroup: "Path",
            children: (0, _jsxRuntime.jsx)(_components.p, {
              children: "Unique identifier for a particular blog."
            })
          })
        })]
      })
    })]
  });
}
function MDXContent(props = {}) {
  const {
    wrapper: MDXLayout
  } = Object.assign({}, (0, _react.useMDXComponents)(), props.components);
  return MDXLayout ? (0, _jsxRuntime.jsx)(MDXLayout, Object.assign({}, props, {
    children: (0, _jsxRuntime.jsx)(_createMdxContent, props)
  })) : _createMdxContent(props);
}
var _default = exports.default = MDXContent;
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}